import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["programSelect", "startDate", "contractDays", "endDate"]
  static values = { programsUrl: String, companyId: Number }

  portfolioChanged(event) {
    const portfolioId = event.target.value
    const select = this.programSelectTarget

    select.innerHTML = `<option value="">None</option>`

    if (!portfolioId) return

    fetch(`/company/portfolios/${portfolioId}/programs`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(programs => {
        programs.forEach(program => {
          const option = document.createElement("option")
          option.value = program.id
          option.textContent = program.name
          select.appendChild(option)
        })
      })
  }

  startDateChanged() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget || !this.hasContractDaysTarget) return
    const start = this.startDateTarget.value
    const end = this.endDateTarget.value
    const days = parseInt(this.contractDaysTarget.value, 10)

    if (start && days > 0) {
      this._setEndDateFromDays(start, days)
    } else if (start && end) {
      this._setContractDaysFromDates(start, end)
    }
  }

  endDateChanged() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget || !this.hasContractDaysTarget) return
    const start = this.startDateTarget.value
    const end = this.endDateTarget.value
    const days = parseInt(this.contractDaysTarget.value, 10)

    if (start && end) {
      this._setContractDaysFromDates(start, end)
    } else if (end && days > 0 && !start) {
      this._setStartDateFromDays(end, days)
    }
  }

  contractDaysChanged() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget || !this.hasContractDaysTarget) return
    const start = this.startDateTarget.value
    const days = parseInt(this.contractDaysTarget.value, 10)

    if (!days || days <= 0) {
      this._setFlatpickrDate(this.endDateTarget, "")
      return
    }

    if (start) {
      this._setEndDateFromDays(start, days)
    } else if (end) {
      this._setStartDateFromDays(end, days)
    }
  }

  _setContractDaysFromDates(startStr, endStr) {
    let diff = Math.round((this._parseDate(endStr) - this._parseDate(startStr)) / (1000 * 60 * 60 * 24))
    if (this.companyIdValue === 549) diff += 1
    this.contractDaysTarget.value = diff > 0 ? diff : ""
  }

  _setEndDateFromDays(startStr, days) {
    const date = this._parseDate(startStr)
    const offset = this.companyIdValue === 549 ? days - 1 : days
    date.setDate(date.getDate() + offset)
    this._setFlatpickrDate(this.endDateTarget, date)
  }

  _setStartDateFromDays(endStr, days) {
    const date = this._parseDate(endStr)
    const offset = this.companyIdValue === 549 ? days - 1 : days
    date.setDate(date.getDate() - offset)
    this._setFlatpickrDate(this.startDateTarget, date)
  }

  // new Date("Y-m-d") parses as UTC midnight; local getDate/setDate math on it
  // lands a day early anywhere west of UTC. Parse into local date parts instead.
  _parseDate(str) {
    const [y, m, d] = str.split("-").map(Number)
    return new Date(y, m - 1, d)
  }

  _setFlatpickrDate(input, date) {
    const fp = input._flatpickr
    if (fp) {
      // Never trigger change here: it would re-enter our own handlers and
      // overwrite the field the user just typed.
      fp.setDate(date, false)
    } else {
      input.value = date ? this._formatDate(date) : ""
    }
  }

  _formatDate(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }
}
